import React from 'react';
import {
  ActionCard,
  Anchor,
  AppButton,
  Box,
  Inscription,
  PlanPendingIcon,
  Preloader,
  Text,
  useFormContext,
} from '@common-fe/common-fe';

import { PayoutDefinitionFormValues } from '../../../PayoutDefinitionSetup.types';
import { GLOBAL_VALIDATION_MESSAGE } from '../../PayoutOrder/hooks/usePayoutOrderValidation';

interface FinalSetupProps {
  onSave: () => void;
  isLoading: boolean;
  isEditMode: boolean;
  onActivateEditMode: () => void;
}

const FinalSetup: React.FC<FinalSetupProps> = ({ onSave, isLoading, isEditMode, onActivateEditMode }) => {
  const {
    formState: { errors },
  } = useFormContext<PayoutDefinitionFormValues>();
  // Derived validation: show error message if there are any form errors
  const hasErrors = Object.keys(errors).length > 0;
  const validationMessage = hasErrors ? GLOBAL_VALIDATION_MESSAGE : null;

  return (
    <Box data-testid="final-setup_wrapper" width={{ max: 'calc(50% - 4px)' }} style={{ minHeight: 'auto' }}>
      <Box style={{ minHeight: 'auto' }}>
        <ActionCard
          title="Save the Payout Definition"
          icon={<PlanPendingIcon size="xxlarge" color="iconAccent" />}
          minHeight="auto"
        >
          <Box width="100%">
            <AppButton
              testId="final-setup_save-button"
              color="blue"
              width="100%"
              size="L"
              onClick={onSave}
              disabled={isLoading || !isEditMode}
            >
              {isLoading ? <Preloader /> : 'Save Changes'}
            </AppButton>
            {!isEditMode && (
              <Box data-testid="final-setup_switch-to-edit" margin={{ top: 'spacing12' }} align="center">
                <Text size="medium" color="textSecondary">
                  To apply any changes, please switch to{' '}
                  <Anchor onClick={onActivateEditMode} weight="normal" label="Edit mode" />.
                </Text>
              </Box>
            )}
            {validationMessage && (
              <Box data-testid="final-setup_validation-error" margin={{ top: 'spacing12' }} align="center">
                <Inscription size="medium" color="danger" textAlign="center" lineHeight="18px">
                  {validationMessage}
                </Inscription>
              </Box>
            )}
          </Box>
        </ActionCard>
      </Box>
    </Box>
  );
};

export default FinalSetup;
